import { ButtonDanger, ButtonLight } from 'front-end/src/components'
import React, { useContext } from 'react'

import { t, Trans } from '@lingui/macro'

import { Modal } from '../../../../components/common/modal/Modal'
import { notification } from '../../../../components/common/notifications/Notifications'
import { ManageSurveyContext } from '../ManageSurveyContext'
import { useDeleteSurveyQuestionMutation } from './SurveyQuestionDeleteModal.codegen'

export interface ISurveyQuestionDeleteModalProps {
  show?: boolean
  questionId: number
  onHide: () => void
}

export default (props: ISurveyQuestionDeleteModalProps) => {
  const { survey, refetchSurvey } = useContext(ManageSurveyContext)
  const { onHide, show, questionId } = props
  const [deleteQuestion, { loading }] = useDeleteSurveyQuestionMutation()

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={t`Delete this question?`}
      controls={[
        <ButtonLight key={1} onClick={onHide}>
          <Trans>Cancel</Trans>
        </ButtonLight>,
        <ButtonDanger
          key={2}
          onClick={async () => {
            const { data } = await deleteQuestion({
              variables: {
                id: questionId,
                surveyId: survey.id
              }
            })

            if (data?.admin?.survey?.question?.delete) {
              await refetchSurvey()
              notification.info(t`Question successfully deleted`)
              onHide()
            } else {
              notification.error(
                t`Question couldn't be deleted, please try again.`
              )
            }
          }}
          isLoading={loading}
        >
          <Trans>Delete</Trans>
        </ButtonDanger>
      ]}
    >
      <Trans>This cannot be undone</Trans>
    </Modal>
  )
}
